export default __webpack_public_path__ + "static/media/photo--sm--team.9d0b38d0.jpg";